import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em 0;

  @media (max-width: 720px) {
    padding: 1em;
  }
`;

export const FlexCenter = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 720px) {
    justify-content: ${(props) => props.justify};
  }
  & .view {
    padding-right: 8px;
    color: #00000057;
    font-weight: 500;
  }
  & .totalview {
    padding-right: 8px;
    color: #000000b8;
    font-weight: 500;
  }
`;

export const UserImage = styled.img`
  width: ${(props) => (props.qna ? '36px' : '46px')};
  height: ${(props) => (props.qna ? '36px' : '46px')};
  border-radius: 50%;
  object-fit: cover;
  filter: ${(props) => props.blur};
`;

export const ArtName = styled.p`
  font-size: ${(props) => (props.qna ? '14px' : '17px')};
  font-weight: 500;
  color: #000000b8;
  padding-left: 10px;
`;
